import SearchBox from 'components/common/SearchBox';
import MyDevicesTable from 'components/devices/MyDevicesTable';
import { useState, ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop } from '@fortawesome/free-solid-svg-icons';

const MyDevices = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div>
      <div className="mb-6">
        <h2
          className="mb-0"
          style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#374151',
            letterSpacing: '-0.025em'
          }}
        >
          <FontAwesomeIcon icon={faLaptop} className="me-2 text-primary" />
          My Devices
        </h2>
        <Row className="g-3 justify-content-end mb-0">
          <Col xs="auto">
            <div className="d-flex gap-2">
              <SearchBox
                placeholder="Search devices..."
                value={searchQuery}
                onChange={handleSearchInputChange}
              />
            </div>
          </Col>
        </Row>

        <div className="mt-3">
          <MyDevicesTable searchQuery={searchQuery} />
        </div>
      </div>
    </div>
  );
};

export default MyDevices;
